const joinWith = char => array => array.join(char);

const toQS = o => joinWith("&")(Object.entries(o).map(joinWith("=")));

const resizeServiceUrl = "https://d20862igapwix5.cloudfront.net";
const defaultRefresh = 24 * 60 * 60 + 1;

const getResizedUrl = ({
  serviceUrl = resizeServiceUrl,
  container = "focus",
  refresh = defaultRefresh,
  url,
  width
}) =>
  `${serviceUrl}?${toQS({
    url,
    container,
    refresh,
    resize_w: width
  })}`;

export default getResizedUrl;
